// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"bd8934bc","800":"18e1ca8a"}[chunkId] + ".chunk.css";
};